import { Stack } from '@mui/material';
import React, { PropsWithChildren } from 'react';

const FormFooter = ({ children }: PropsWithChildren) => (
  <Stack alignSelf="flex-end" direction="row" gap="1rem" justifyContent="end">
    {children}
  </Stack>
);

export default FormFooter;
